import { useTranslation } from 'react-i18next';
import React, {useState, useEffect, Fragment} from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from '../../functions/api';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { Table, TableBody, TableHead, TableCell, Box, TableRow, TableContainer, TextField, MenuItem, Button } from '@mui/material';
import { useMessage } from "../../context/message-context";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
function TimeCorrectionComponent(props) {
  const { t } = useTranslation();
  const {client, accessToken} = props;
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const {hideMessage, showErrorMessage} = useMessage();
  const [anzeige,setAnzeige]=useState(localStorage.getItem("PZKOA0_FILTER") ? Number(localStorage.getItem("PZKOA0_FILTER")) : 0);
  useEffect(() => {
    setIsLoading(true);
    const payload={
      "mandant": client, // this.props.client,
      "program": "PZKOA0",
      "statement": "TABLE",
    }
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, tableCb);
    // eslint-disable-next-line
  }, [])
  const filter_aendern = (filter) => {
    localStorage.setItem("PZKOA0_FILTER",filter)
    setAnzeige(filter);
  }
  const tableCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.items) {
        setItems(response.data.items);
      }
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
      navigate(-1);
    }
  }
  const open = (rcount, e) => {
    e.preventDefault();
    e.stopPropagation();
    if (items[rcount].status === '0'||items[rcount].status === '4') {
      var tmpDate = items[rcount].key;
      console.log(tmpDate);
      tmpDate = tmpDate.slice(0,4)+'-'+tmpDate.slice(4,6)+'-'+tmpDate.slice(6,8);
      navigate('/PZKOA0/new/'+tmpDate);
    } else {
      navigate('/PZKOA0/edit/M'+"000"+items[rcount].dbkey)
    }
  }
  if (isLoading) {
    return <LoadingComponent />
  }
  const displayValues = items.map((element, count) => {
    var backColor = ''
    if (element.state === 'Fehler'||element.state === 'Fehltag') backColor = '#ff000033'
    if (element.state === 'neu') backColor = '#22bbaa33';
    if (element.status === '4' || element.status === '2') backColor = '#22bbaa33';
    if (anzeige===0&&element.art==="ARCHIV"){
      return(undefined);
    }
    if (anzeige===1&&element.state!=="Fehler"&&element.state!=="Fehltag"){
      return(undefined);
    }
    if (anzeige===2&&element.art!=="ARCHIV"&&element.art!=="AKTUELL"){
      return(undefined);
    }
    return(
      <TableRow style={{backgroundColor: backColor, cursor: 'pointer'}} key={count} onClick={(e) => open(count, e)}>
        <TableCell >{element.datetext}</TableCell>
        <TableCell >{element.timestring}</TableCell>
        <TableCell >{element.state}</TableCell>
      </TableRow>
    );
  });
  return (
    <Fragment>
    <Page>
      <Layout fullWidth>
        <Box pt={1} pb={1}>
          <Button variant="contained" color="primary" onClick={() => navigate('/PZKOA0/new')}>{t("Neuer Korrekturantrag")}</Button>
        </Box>
      </Layout>
      <Layout>
        <Box pl={2} pr={2} pt={1} pb={1}>
        <TextField
        id="anzeige"
        label={t("Anzeige")}
        select
        fullWidth
        value={anzeige}
        onChange={(e) => {filter_aendern(e.target.value)}}
        variant="outlined"
      >
          <MenuItem key={0} value={0}>{t("Aktuell")}</MenuItem>
          <MenuItem key={1} value={1}>{t("Nur Fehler")}</MenuItem>
          <MenuItem key={2} value={2}>{t("Antragsarchiv")}</MenuItem>
      </TextField>
        </Box>
      <TableContainer >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>{t("Tag")}</TableCell>
              <TableCell>{t("Zeit")}</TableCell>
              <TableCell>{t("Info")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayValues}
          </TableBody>
        </Table>
      </TableContainer>
      </Layout>
    </Page>
    </Fragment>
  );
}
export default TimeCorrectionComponent;
